export const GET_TYPE = (identifier) => `https://pokeapi.co/api/v2/type/${identifier}`;
